let hsmsData = [
    {
        name: "Primary HSM",
        pkcs11Path: "/usr/local/lib/softhsm/libsofthsm2.so",
        cryptokiVersion: "2.40",
        libraryDescription: "Implementation of PKCS11",
        libraryVersion: "2.6",
        tokens: [
            {
                label: "Token1",
                manufacturerId: "SoftHSM project",
                model: "SoftHSM v2",
                serialNumber: "abcdefg",
                rng: true,
                writeProtected: false,
                tokenInitialized: true,
                errorState: false,
                hardwareVersion: "2.6",
                firmwareVersion: "2.6",
                bytes: 1024,
                seconds: 10,
                lastSeedStatus: {
                    pkcs11Path: "/usr/local/lib/softhsm/libsofthsm2.so",
                    serialNumber: "abcdefg",
                    timestamp: Math.floor(Date.now() / 1000),
                    success: Math.random() < 0.8
                }
            },
            {
                label: "Token2",
                manufacturerId: "SoftHSM project",
                model: "SoftHSM v2",
                serialNumber: "hijklmnop",
                rng: true,
                writeProtected: false,
                tokenInitialized: true,
                errorState: false,
                hardwareVersion: "2.6",
                firmwareVersion: "2.6",
                bytes: 32,
                seconds: 15,
                lastSeedStatus: {
                    pkcs11Path: "/usr/local/lib/softhsm/libsofthsm2.so",
                    serialNumber: "hijklmnop",
                    timestamp: Math.floor(Date.now() / 1000),
                    success: Math.random() < 0.8
                }
            }
        ]
    },
    {
        name: "Secondary HSM",
        pkcs11Path: "/workspaces/secondaryhsm/lib/softhsm/libsofthsm2.so",
        cryptokiVersion: "2.40",
        libraryDescription: "Implementation of PKCS11",
        libraryVersion: "2.6",
        tokens: [
            {
                label: "Backup1",
                manufacturerId: "SoftHSM project",
                model: "SoftHSM v2",
                serialNumber: "1234567890",
                rng: true,
                writeProtected: false,
                tokenInitialized: true,
                errorState: false,
                hardwareVersion: "2.6",
                firmwareVersion: "2.6",
                bytes: 4096,
                seconds: 20,
                lastSeedStatus: {
                    pkcs11Path: "/workspaces/secondaryhsm/lib/softhsm/libsofthsm2.so",
                    serialNumber: "1234567890",
                    timestamp: Math.floor(Date.now() / 1000),
                    success: Math.random() < 0.8
                }
            }
        ]
    }
];
export default hsmsData;
